export enum EShowMode {
    ENABLED = "ENABLED",
    DISABLED = "DISABLED",
    NULL = "NULL",
}

export enum EBenefitTypes {
    /**
     * Allow businesses to find and connect with workers (cleaners) from directory.
     * Typical capabilities: search, view profiles, initiate contact/request.
     */
    FINDACLEANER = "findacleaner",

    /**
     * Access to customer support channels (email) and help resources.
     */
    SUPPORT = "support",

    /**
     * Configure and manage service coverage areas where the business operates.
     * Used to restrict findacleaner to defined areas.
     */
    AREASCOVERAGES = "areascoverages",
    /**
     * Client management module (CRM): create/edit clients, addresses.
     */
    CLIENT_MANAGEMENT = "client_management",

    /**
     * Basic quoting functionality.
     * Typical capabilities: create simple quotes.
     */
    QUOTES_BASIC = "quotes_basic",

    /**
     * Invoicing module.
     * Typical capabilities: create invoices, send invoices, track payment status, record payments.
     */
    INVOICING = "invoicing",

    /**
     * Scheduling and calendar functionality.
     * Typical capabilities: create jobs/appointments (visits), view staff in calendar, calendar views.
     */
    SCHEDULING = "scheduling",

    /**
     * Access to the mobile application (staff or business app).
     * Enables authentication and usage of mobile-only experiences (job execution, notifications, etc).
     */
    MOBILE_APP = "mobile_app",

    // Sol Pro

    /**
     * Client-facing portal/hub for customers to view and manage their relationship with the business.
     * Typical capabilities: view upcoming jobs, approve quotes, pay invoices, view documents/messages.
     *
     * TODO: Confirm exact scope and rename if needed.
     */
    CLIENT_HUB = "client_hub",

    /**
     * Advanced quoting functionality beyond basic quotes, define categories, places, services, areas, objects, special requests.
     */
    QUOTES_ADVANCED = "quotes_advanced",

    /**
     * Statement of Work (SOW) PDF generation and sharing.
     * Typical capabilities: generate SOW documents from job/quote data and export/share as PDF.
     */
    SOW_PDF = "sow_pdf",

    /**
     * Electronic signature support for documents (quotes/SOW/contracts).
     * Typical capabilities: request signature, audit trail, signed document storage, implement Docusign for advanced quotes.
     */
    E_SIGNATURE = "e_signature",

    /**
     * Seat-based access counter for internal users (admins/workforce).
     * Used to limit how many team members can be active under a company.
     * Commonly enforced as a limitedUsage counter (non-monthly reset).
     */
    SEATS = "seats",

    /**
     * Kanban tables to create and manage tasks.
     */
    FLOW_DO = "flow_do",

    /**
     * Basic analytics/metrics.
     * Typical capabilities: high-level dashboards and simple reporting (revenue, jobs count).
     */
    METRICS_BASIC = "metrics_basic",

    // Start Up

    /**
     * Recurring jobs, generate jobs that allow to create future events.
     * Typical capabilities: create recurring schedules, generate future instances.
     */
    RECURRING_JOBS = "recurring_jobs",

    /**
     * Employee GPS tracking for workforce in the field.
     * Typical capabilities: location pings, route playback.
     */
    EMPLOYEE_GPS_TRACKING = "employee_gps_tracking",

    /**
     * Timesheets/time tracking for staff.
     * Typical capabilities: clock in/out, job-based time logs, approval flow, payroll export support.
     */
    TIME_SHEETS = "time_sheets",

    /**
     * Secure password vault for storing shared credentials per company.
     * Typical capabilities: encrypted storage, role-based access, audit logs, 2FA authentication.
     */
    PASSWORD_VAULT = "password_vault",

    // Business

    /**
     * Onboarding specialist service/entitlement.
     * Typical capabilities: guided setup, training sessions, migration assistance (non-product feature).
     */
    ONBOARDING_SPECIALIST = "onboarding_specialist",

    /**
     * Advanced analytics/metrics beyond basic dashboards.
     * Typical capabilities: deeper reporting, segmentation, performance metrics, exports, trends.
     */
    METRICS_ADVANCED = "metrics_advanced",

    /**
     * Real-time team communication for internal staff.
     * Typical capabilities: chat, file/voice attachments.
     */
    TEAM_REAL_TIME_COMMUNICATION = "team_real_time_communication",

    /**
     * Customer communication tooling (virtual receptionist / messaging integrations).
     * Typical capabilities: inbound/outbound messaging, call/SMS routing, notifications (Twilio integration).
     */
    CUSTOMER_COMMUNICATION = "customer_communication",

    /**
     * Advanced routing and job optimization.
     * Typical capabilities: route planning, multi-stop optimization, territory planning, dispatch tooling.
     */
    ADVANCED_ROUTES_JOBS = "advanced_routes_jobs",

    /**
     * AI assistant/chat experience ("Lili") for product help and workflow assistance.
     * Typical capabilities: chat-based guidance, automation suggestions, contextual Q&A.
     */
    LILI_OPEN_IA_CHAT = "lili_open_ia_chat",

    /**
     * Website/page builder module for creating and managing company landing pages.
     * TODO: Replace/remove if the backend exposes this entitlement with another key.
     */
    PAGE_BUILDER = "page_builder",

    // Flow mobile benefits.
    FLOW_MOBILE_UNLIMITED_CALLS = "flow_mobile_unlimited_calls",
    FLOW_MOBILE_LOCAL_NUMBER = "flow_mobile_local_number",
    FLOW_MOBILE_CALL_FORWARDING = "flow_mobile_call_forwarding",
    FLOW_MOBILE_VOICEMAIL = "flow_mobile_voicemail",
    FLOW_MOBILE_VOICEMAIL_TRANSCRIPTION = "flow_mobile_voicemail_transcription",
    FLOW_MOBILE_CALL_RECORDING = "flow_mobile_call_recording",
    FLOW_MOBILE_CALL_RECORDING_TRANSCRIPTION = "flow_mobile_call_recording_transcription",
    FLOW_MOBILE_SMS_1_1 = "flow_mobile_sms_1_1",
    FLOW_MOBILE_SMS_1_N = "flow_mobile_sms_1_n",
    FLOW_MOBILE_SUPPORT = "flow_mobile_support",
    FLOW_MOBILE_CALL_STORAGE = "flow_mobile_call_storage",
    FLOW_MOBILE_CALL_QUEUE = "flow_mobile_call_queue",
    FLOW_MOBILE_CALL_IVR = "flow_mobile_call_ivr",
}
